import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { handleSsoTokenHandoff } from './services/auth';
import './i18n';
import App from './App';

// Handle SSO token handoff from Chrome extension BEFORE Amplify configures.
// This stores extension tokens in Amplify's expected localStorage format
// so the Authenticator detects the session and skips the login screen.
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID as string;
handleSsoTokenHandoff(clientId);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: clientId,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN as string,
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [`${import.meta.env.VITE_WEB_URL}/callback`],
          redirectSignOut: [import.meta.env.VITE_WEB_URL as string],
          responseType: 'code',
        },
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
